import { render, staticRenderFns } from "./summary-value-per.vue?vue&type=template&id=37b6d0f5&"
import script from "./summary-value-per.vue?vue&type=script&lang=js&"
export * from "./summary-value-per.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports